/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {GetterTree} from 'vuex';
import {RootState} from '@/store/types';
import {UgcNotificationItemInterface, UgcNotificationStateInterface} from '@/store/modules/ugc-notification/types';

/**
 * The UGC notification module getters provide entry points for stored data.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const getters: GetterTree<UgcNotificationStateInterface, RootState> = {
    /**
     * Get the unactioned notification items from the state.
     *
     * @param {UgcNotificationStateInterface} state
     *
     * @returns {UgcNotificationItemInterface[]}
     */
    unactioned(state: UgcNotificationStateInterface): UgcNotificationItemInterface[] {
        return state.items.filter((item: UgcNotificationItemInterface) => {
            return true !== item.presented;
        });
    },
};
